import { featuredArticle } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[680px] mx-3 md:mx-5 mt-3 md:mt-5 rounded-[24px] md:rounded-[32px] overflow-hidden">
      <img
        src={featuredArticle.image}
        alt="头条爆料背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center w-full px-4 md:px-8">
        <div className="text-center max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 text-white text-xs md:text-sm font-medium tracking-wide mb-5 md:mb-7 backdrop-blur-sm">
            🔥 今日头条爆料
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight md:leading-tight mb-4 md:mb-6 tracking-tight">
            {featuredArticle.title}
          </h1>

          <p className="text-sm md:text-base text-white/80 font-light leading-relaxed max-w-xl mx-auto mb-6 md:mb-8">
            {featuredArticle.excerpt}
          </p>

          <div className="flex items-center justify-center gap-4 md:gap-6 text-white/70 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line"></i>
              {featuredArticle.date}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-line"></i>
              {featuredArticle.views} 阅读
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-chat-3-line"></i>
              {featuredArticle.comments.toLocaleString()} 评论
            </span>
          </div>

          <Link
            to={`/article/${featuredArticle.slug}`}
            className="inline-flex items-center gap-2 mt-7 md:mt-9 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            查看详情
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-1.5">
        <span className="w-2 h-2 rounded-full bg-white"></span>
        <span className="w-2 h-2 rounded-full bg-white/40"></span>
        <span className="w-2 h-2 rounded-full bg-white/40"></span>
      </div>
    </section>
  );
}